
import e from "../../images/e.png";





import deveop from "../../images/deveop.png";
import development from "../../images/development.jpg";
import bgImage2 from "../../images/glow.png";
import './Development.css';

import { useNavigate } from 'react-router-dom';


import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState, useRef } from 'react';

// import FileUploader from './FileUploader';


export const Development = () => {
  const navigate = useNavigate();

  const [width, setWidth] = useState(window.innerWidth);
  const heroRef = useRef<HTMLDivElement | null>(null);
  const backgroundRef = useRef<HTMLDivElement | null>(null);


  useEffect(() => {
    const animateValue = (obj: HTMLElement, start: number, end: number, duration: number) => {
      let startTimestamp: number | null = null;
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start).toString();
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };
  
    // Select all elements with a specific class
    const elements = document.querySelectorAll<HTMLElement>(".animate-value");
  
    if (elements.length === 0) {
      console.error("No elements with class 'animate-value' found in the DOM.");
      return;
    }
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const endValue = parseInt(target.getAttribute("data-end") || "100", 10); // Use `data-end` for dynamic values
            animateValue(target, 0, endValue, 2000); // Start animation
            observer.unobserve(target); // Stop observing this element after animation starts
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the element is visible
    );
  
    // Observe each element
    elements.forEach((element) => observer.observe(element));
  
    return () => {
      observer.disconnect(); // Cleanup observer on component unmount
    };
  }, []);
  
  useEffect(() => {
    if (heroRef.current && backgroundRef.current) {
      heroRef.current.style.background = 'none';
      backgroundRef.current.style.backgroundImage = `url(${bgImage2})`;
    }
    const handleScroll = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = maxScaleTop;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.transformOrigin = 'bottom right';
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-26.47 * scaleside) + 36.47}%`;
      }
    };
    const handleScrollMobile = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = 1.8;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        // backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.txransformOrigin = 'bottom right';
        // backgroundRef.current.style.top = `${(-22.05 * scaleTop) + 47}%`;
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-30.47 * scaleside) + 26.47}%`;
      }
    };
    const updateScrollHandler = () => {
      const isMobile = window.innerWidth <= 900; // Adjust breakpoint as needed
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
  
      if (isMobile) {
        window.addEventListener('scroll', handleScrollMobile);
      } else {
        window.addEventListener('scroll', handleScroll);
      }
    };
  
    // Set the initial scroll handler
    updateScrollHandler();
     // Update the scroll handler on resize
  window.addEventListener('resize', updateScrollHandler);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
      window.removeEventListener('resize', updateScrollHandler);
    };
}, []);


 
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <div id="wrapper2_d">
    <section id='hero2_d' ref={heroRef} className="hero2_d"
    // style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'auto', background: 'cover' }}
    >
         <div   className='glow_2'></div>

<div ref={backgroundRef} className="background">
<div   ref={backgroundRef}className='glow'></div>
</div>
<div className="background2"></div>
      {/* <div ref={backgroundRef} className="background">
      Staffing
      </div> */}
      <div className='hero__flex'  >
     
      <div className='hero__left'  >
      <div className='img_box'>
      <img src={development}  className='intro_img first'  />
      <img src={deveop}  className='intro_img'  />
      {/* <img src={staff}  className='intro_img'  />   */}
      <div className='intro_img'>
      <div style={{display:'flex',flexDirection:'row',justifyContent:'center',}}>
        <div className="num animate-value"  data-end="8">0</div><a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a>
        </div>
        <div className="text">Trusted Clients</div>
      </div>
 <div className='intro_img'>
 <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
        <div className="num animate-value"  data-end="10">0</div><a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a>
        </div>
        <div className="text">Projects Done</div>
      </div>
            </div>
         </div>
        
         <div className='hero__right'  >
         <div>
        <div className='rightbox_paragraph_up'>
     Development
            </div>
            <a>-Intell<img src={e} className='elogo' />Sphere</a>
            </div>
           
      <div className='rightbox_paragraph'>
      At IntelleSphere LLC, we don’t just build software—we create intelligent, scalable solutions
that fuel innovation, streamline operations, and accelerate business growth. As a leading
provider of IT staffing and software development services in the USA, we combine deep
technical expertise with business insight to deliver software that aligns with your strategic
goals.
Whether you're a tech startup looking for rapid product development or an enterprise
modernizing legacy systems, IntelleSphere offers full-cycle custom software development
services—from concept to deployment and beyond. Our agile-driven teams help you turn ideas
into high-performance, secure, and scalable applications.   </div>
           
           
         </div>
      
      </div>
    </section>

    <div className='section3_d'>
    {/* <a>WHAT WE DO</a>
            <h1>Services at Tekcog</h1> */}
           <div className='sevices_in_d'>
            <div className='sevices_box_d animate'>
       
            <a>Finding the Right People</a>
           
            <p>We connect you with talented IT professionals who are more
than just a resume. We find individuals who fit your culture and become part of your
team.</p>
        
            </div>
            
            <div className='sevices_box_d animate'>
            <img
            // src={devops}
            className='animeImg'
            
            />
            <a>Turning Ideas into Reality</a>
           
            <p>Got a vision for an app or service? We&#39;re excited to help you
build it! We craft custom software that feels like it was made just for you.</p>
        
            </div>
       
     
            {/* <img
            src={Tlogo}
            className='imageSide'
            
            /> */}
           </div>
           <div className='sevices_in2_d '>
         
 

         <div className='sevices_box2_d animate'>
         <img
         // src={s}
         className='animeImg'
         
         />
         <a>Enabling Seamless Communication</a>
        
         <p>We make sure your systems work together
harmoniously. We create a cohesive collaborative communication platforms that
streamlines your operations and enhances collaboration.</p>
     
         </div>
         <div className='sevices_box2_d animate'>
         <img
         // src={dMedia}
         className='animeImg'
         
         />
         <a>Building the Right Foundations</a>
        
         <p>We create enterprise software solutions that are
robust and scalable, designed to support your growth and streamline your operations.</p>
     
         </div>
         <div className='sevices_box2_d animate'>
         <img
         // src={dMedia}
         className='animeImg'
         
         />
         <a>Supporting You Every Step of the Way</a>
        
         <p>Our support and maintenance ensures your
technology runs smoothly, allowing you to focus on what matters most.</p>
     
         </div>
         {/* <img
         src={Tlogo}
         className='imageSide'
         
         /> */}
        </div>
          
    </div>
    {/* <div className='section4_P'>
    <div className='center animate'>
            <img src={gif} className='logoIS' />
             </div>
   <h1>We have formulated our solutions to cater to needs of individual industries and
their custom requirements, our expertise include various sectors like</h1>
<div className='sec_contain'>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Information Technology (IT)</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Healthcare &Life Sciences</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Finance & Accounting</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Engineering & Manufacturing</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Logistics & Supply Chain</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Administrative & Customer Support</h1>
            </div>
           </div>
           <h2>where we cater to Contract Staffing (Temporary & Project-Based), Contract-to-
Hire Staffing, Direct Hire Recruitment, Executive Search & Niche Talent
Acquisition</h2>
           </div> */}

  
          
    </div>
    
    
  )
}






